const fvAssetsSha = "fc02386abc2933e15501929c0382e2be1f9d62a9";

export const DEFAULT_ASSET_BASE = `https://fv-assets.mlb.com/v/${fvAssetsSha}`;

export const defaultScale = 3.28084;
